function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1-congratulate{fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:2px;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "congratulate");

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1-congratulate",
  d: "M341.71,295.33c4.1,3.83,3.87,9.76,2.52,10.72-7.22,5.12-30-2.49-50.07-22.54s-29.28-42.6-23-48.86c2.54-2.54,6.71-1.3,12,1.64"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1-congratulate",
  d: "M269.54,237.6s-71.65,110-55.84,125.86C228.84,378.61,342,307.6,342,307.6"
});

var _ref6 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1-congratulate",
  x1: 300.73,
  y1: 276.68,
  x2: 321.24,
  y2: 257.86
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1-congratulate",
  d: "M328.07,292.53s38.22-26.41,44-2.07"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1-congratulate",
  cx: 265.04,
  cy: 188.02,
  r: 6.58
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1-congratulate",
  cx: 354.93,
  cy: 197.36,
  r: 4.05
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1-congratulate",
  cx: 402.11,
  cy: 241.78,
  r: 4.18
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1-congratulate",
  cx: 397.64,
  cy: 281.33,
  r: 6.01
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1-congratulate",
  cx: 306.24,
  cy: 347.65,
  r: 3.23
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1-congratulate",
  d: "M279,206c27.91-5.57,17.21,23.54,17.21,23.54"
});

var _ref14 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1-congratulate",
  x1: 292.51,
  y1: 238.62,
  x2: 286.56,
  y2: 251.53
});

var _ref15 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1-congratulate",
  x1: 325.29,
  y1: 205.26,
  x2: 325.29,
  y2: 213.31
});

var _ref16 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1-congratulate",
  x1: 361.23,
  y1: 255.83,
  x2: 373.38,
  y2: 255.83
});

var _ref17 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1-congratulate",
  x1: 350.88,
  y1: 257.86,
  x2: 342.03,
  y2: 263.68
});

var _ref18 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1-congratulate",
  x1: 333.64,
  y1: 270.44,
  x2: 328.07,
  y2: 275.32
});

var _ref19 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1-congratulate",
  x1: 228.6,
  y1: 235.83,
  x2: 240.24,
  y2: 221.15
});

var _ref20 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1-congratulate",
  x1: 227.33,
  y1: 222.67,
  x2: 241.43,
  y2: 233.28
});

var _ref21 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1-congratulate",
  x1: 318.43,
  y1: 188.79,
  x2: 322.62,
  y2: 170.53
});

var _ref22 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1-congratulate",
  x1: 311.62,
  y1: 177.45,
  x2: 328.91,
  y2: 180.96
});

var _ref23 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1-congratulate",
  x1: 383.55,
  y1: 207.05,
  x2: 384.99,
  y2: 194.09
});

var _ref24 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1-congratulate",
  x1: 377.94,
  y1: 199.76,
  x2: 390.17,
  y2: 200.79
});

var _ref25 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1-congratulate",
  x1: 350.76,
  y1: 336.21,
  x2: 363.41,
  y2: 322.38
});

var _ref26 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1-congratulate",
  x1: 350.42,
  y1: 322.99,
  x2: 363.74,
  y2: 334.55
});

var _ref27 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1-congratulate",
  x1: 372.11,
  y1: 297.97,
  x2: 372.11,
  y2: 299.94
});

var _ref28 = /*#__PURE__*/React.createElement("polyline", {
  className: "cls-1-congratulate",
  points: "305.45 248.68 310.99 245.96 310.99 238.62 316.84 237.6 316.84 229.51 321.24 226.55"
});

var _ref29 = /*#__PURE__*/React.createElement("polyline", {
  className: "cls-1-congratulate",
  points: "330.86 245.96 336.56 245.96 336.56 238.62 342.03 238.62 342.03 233.28 347.51 233.28"
});

var SvgCongratulate01 = function SvgCongratulate01(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 585.02 580.93",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCongratulate01, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/congratulate-01.3362dfa7.svg";
export { ForwardRef as ReactComponent };